import React, { useEffect, useState } from 'react';

const formatLabel = (val) => {
  if (!val) return '—';
  return val.replace(/_/g, ' ');
};

const SiteModal = ({ site, draft, enums, onClose, onSubmit, onPickOnMap }) => {
  const isEdit = Boolean(site);
  const [name, setName] = useState('');
  const [gpsLat, setGpsLat] = useState('');
  const [gpsLng, setGpsLng] = useState('');
  const [what3words, setWhat3words] = useState('');
  const [siteConditions, setSiteConditions] = useState('');

  useEffect(() => {
    setName(draft?.name ?? site?.name ?? '');
    setGpsLat(draft?.gps_lat != null ? String(draft.gps_lat) : site?.gps_lat != null ? String(site.gps_lat) : '');
    setGpsLng(draft?.gps_lng != null ? String(draft.gps_lng) : site?.gps_lng != null ? String(site.gps_lng) : '');
    setWhat3words(draft?.what3words ?? site?.what3words ?? '');
    setSiteConditions(draft?.site_conditions ?? site?.site_conditions ?? '');
  }, [site, draft]);

  const conditions = enums.site_conditions || [];

  const currentForm = () => ({
    name,
    gps_lat: gpsLat ? parseFloat(gpsLat) : null,
    gps_lng: gpsLng ? parseFloat(gpsLng) : null,
    what3words: what3words || null,
    site_conditions: siteConditions || null,
  });

  const handlePickOnMap = () => {
    onPickOnMap?.({
      name,
      gps_lat: gpsLat ? parseFloat(gpsLat) : null,
      gps_lng: gpsLng ? parseFloat(gpsLng) : null,
      what3words: what3words || null,
      site_conditions: siteConditions || null,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name) return;
    onSubmit(currentForm());
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{isEdit ? 'Edit site' : 'Create site'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g. Avenham Park"
              required
            />
          </div>
          <div className="form-group">
            <label>Location</label>
            <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
              <input
                type="number"
                step="any"
                value={gpsLat}
                onChange={(e) => setGpsLat(e.target.value)}
                placeholder="Latitude"
                style={{ flex: 1 }}
              />
              <input
                type="number"
                step="any"
                value={gpsLng}
                onChange={(e) => setGpsLng(e.target.value)}
                placeholder="Longitude"
                style={{ flex: 1 }}
              />
            </div>
            <button
              type="button"
              className="btn btn-secondary btn-touch"
              style={{ color: '#333', background: '#eee', width: '100%' }}
              onClick={handlePickOnMap}
            >
              Select point on map
            </button>
          </div>
          <div className="form-group">
            <label>What3Words</label>
            <input
              value={what3words}
              onChange={(e) => setWhat3words(e.target.value)}
              placeholder="e.g. sends.villa.push"
            />
          </div>
          {conditions.length > 0 && (
            <div className="form-group">
              <label>Site conditions</label>
              <select value={siteConditions} onChange={(e) => setSiteConditions(e.target.value)}>
                <option value="">—</option>
                {conditions.map((c) => (
                  <option key={c} value={c}>{formatLabel(c)}</option>
                ))}
              </select>
            </div>
          )}
          <div className="modal-actions">
            <button type="button" className="btn btn-secondary btn-touch" style={{ color: '#333', background: '#eee' }} onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary btn-touch">{isEdit ? 'Save' : 'Create'}</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SiteModal;
